import { render, staticRenderFns } from "./actuFestivalCard.vue?vue&type=template&id=097d563a&"
import script from "./actuFestivalCard.vue?vue&type=script&lang=js&"
export * from "./actuFestivalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports